type IpWhoResponse = {
  success?: boolean;
  country_code?: string;
};

const IP_COUNTRY_LOOKUP_URL = "https://ipwho.is/";

/**
 * Resolve the visitor's ISO country code without persisting the IP response.
 * Callers should use this only where a browser/server IP signal is available
 * and keep a local fallback for native or unavailable-network paths.
 */
export async function getIpCountryCode(
  signal?: AbortSignal,
): Promise<string | null> {
  try {
    const response = await fetch(IP_COUNTRY_LOOKUP_URL, { signal });
    if (!response.ok) return null;

    const payload = (await response.json()) as IpWhoResponse;
    if (payload.success !== true || typeof payload.country_code !== "string") {
      return null;
    }

    const countryCode = payload.country_code.trim().toUpperCase();
    return /^[A-Z]{2}$/.test(countryCode) ? countryCode : null;
  } catch {
    return null;
  }
}
